module.exports = __webpack_public_path__ + "img/17870_L.8a67b382.png";